import { ProfileState } from './types'

export const state: ProfileState = {
  contacts: null,
  bleContacts: null,
}
